import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FileuploadComponent } from './fileupload.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: FileuploadComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class FileuploadRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/view/fileupload/fileupload-routing.module.ts